import React, { Fragment } from "react";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
// import AddRetailerModal from "./AddRetailerModal";

import LiveIcon from "../../assets/media/icons/live.svg";
import InactiveIcon from "../../assets/media/icons/inactive.svg";

import "./index.css";
import { Link } from "react-router-dom";
import { CurrencyOptions, TerritoryOptions } from "../../Constants/retailer";

class EcoEarnRetailer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      open: 0,
      close: 0,
      waiting: 0,
    };
  }

  onEdit = (event) => {
    const { onEdit, retailer } = this.props;
    event.stopPropagation();
    onEdit(retailer);
  };

  getTokenString = (name) => {
    const { retailer } = this.props;
    const token = retailer[name];

    if (token && token.tokenPercentage) {
      return `${token.fullTokens + token.partTokens} tokens on ${
        CurrencyOptions[retailer.territory || TerritoryOptions[0]]
      }${token.threshold}`;
    }

    return "Not available currently";
  };

  render() {
    const { retailer, onClick, deactive, readOnly, mode, showEdit } =
      this.props;
    const isInactive = deactive === "deactive";

    return (
      <Grid container spacing={2} style={{ alignItems: "center" }}>
        <Grid item xs={2}>
          <div
            style={{
              backgroundImage: `url(${
                retailer.logo ? retailer.logo : retailer
              })`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "contain",
              padding: 20,
              width: "100%",
              height: 150,
            }}
          ></div>
        </Grid>
        <Grid item xs={2}>
          <div
            style={{ fontSize: "20px", color: "black", textAlign: "center" }}
          >
            {retailer.tokenPercentage} in per{" "}
            {CurrencyOptions[retailer.territory || TerritoryOptions[0]]}1
          </div>
        </Grid>
        <Grid item xs={3}>
          <div
            style={{ fontSize: "20px", color: "black", textAlign: "center" }}
          >
            {CurrencyOptions[retailer.territory || TerritoryOptions[0]]}45,056
          </div>
        </Grid>
        {showEdit && (
          <Grid item xs={2}>
            <div
              className={classNames("status", { inactive: isInactive })}
              onClick={() => onClick()}
            >
              <img src={isInactive ? InactiveIcon : LiveIcon} alt="icon" />
              {isInactive ? "INACTIVE" : "LIVE"}
            </div>
          </Grid>
        )}
        {showEdit && (
          <Grid item xs={2} style={{ textAlign: "center" }}>
            <button
              type="button"
              data-toggle="modal"
              data-target="#edit_eco_earning"
              className="btn btn-secondary"
              onClick={this.onEdit}
            >
              Edit
            </button>
          </Grid>
        )}
      </Grid>
    );
  }
}
export default EcoEarnRetailer;



// WEBPACK FOOTER //
// ./src/components/EcoEarnRetailer/index.js